<template lang="pug">
.welcome
  .welcom-main(id="welcome")
    .welcome-head(v-if="!showSharedLoading")
      //- .welcome-head-back(:style="`height: ${backHeight}px;`", @click="onBack")
    .welcome-head-share(v-else)
      img(src="~assets/footprint/title-welcome.png")
    .welcome-body(:class="showSharedLoading ? 'welcome-body-share' : ''")
      .welcome-ask(@click="onGuide", v-if="!showSharedLoading")
      .welcome-msg
        .welcome-msg-name {{user.nickname}}
        .welcome-msg-text
          textarea(maxlength="30", :disabled="!canShared", :placeholder="placeholder", v-model="sharedText", v-if="!showSharedLoading")
          p(v-else) {{sharedText}}
        .welcome-msg-time {{footprintServiceTime}}
        .welcome-msg-icon
          img(src="~assets/footprint/icon-lib.png")
      .welcome-taskBox
        //- 赠送“数字藏品”与“我的蚂蚁森林“两张贴纸
        .welcome-task.welcome-task-1
          img(src="~assets/footprint/2025/task-1.png")
        .welcome-task.welcome-task-2
          img(src="~assets/footprint/2025/task-2.png")
        //- 集齐主线展点三张贴纸出现盲盒贴纸
        .welcome-task.welcome-task-3(v-if="footprintTaskListToday.masterTask.length >= 3", @click="onShowBlindbox")
          img(src="~assets/footprint/task-3.png")
        //- “零碳行动”/“天空之眼”/“拯救消失的能量”/“飞跃蚂蚁森林“ 四主线
        //- id=11 零碳行动 = 碳中和
        .welcome-task.welcome-task-4(v-if="hasMasterTask(11)")
          img(src="~assets/footprint/task-4.png")
        //- id=10 天空之眼 = 大山雀
        .welcome-task.welcome-task-5(v-if="hasMasterTask(10)")
          img(src="~assets/footprint/task-5.png")
        //- id=5 拯救消失的能量 = 互动区
        .welcome-task.welcome-task-6(v-if="hasMasterTask(5)")
          img(src="~assets/footprint/task-6.png")
        //- id=3 飞跃蚂蚁森林
        .welcome-task.welcome-task-7(v-if="hasMasterTask(3)")
          img(src="~assets/footprint/task-7.png")
        //- 支线贴纸&虚线框
        //- id=5 code=4 支线·大山雀的故事 = 天空之眼
        .welcome-task.welcome-task-8(v-if="hasBranchTask(4)")
          img(src="~assets/footprint/task-8.png")
        .welcome-task.welcome-task-8-bd(v-else, @click="onShowBranchQue2")
          img(src="~assets/footprint/task-8-bd.png")
        //- id=7 code=6 支线·飞跃蚂蚁森林
        .welcome-task.welcome-task-9(v-if="hasBranchTask(6)")
          img(src="~assets/footprint/task-9.png")
        .welcome-task.welcome-task-9-bd(v-else, @click="onShowBranchQue")
          img(src="~assets/footprint/task-9-bd.png")
        //- id=2 code=2 支线·支付宝暖科技 = 蚂蚁链NFT
        .welcome-task.welcome-task-10(v-if="hasBranchTask(18)")
          img(src="~assets/footprint/2025/task-10.png")
        .welcome-task.welcome-task-10-bd(v-else, @click="onShowBranchVideo(1)")
          img(src="~assets/footprint/task-10-bd.png")
        //- id=3 code=3 支线·数字藏品
        .welcome-task.welcome-task-11(v-if="hasBranchTask(19)")
          img(src="~assets/footprint/2025/task-11.png")
        .welcome-task.welcome-task-11-bd(v-else, @click="onShowBranchVideo(0)")
          img(src="~assets/footprint/task-11-bd.png")
        //- id=9 code=7 支线·零碳生活
        .welcome-task.welcome-task-12(v-if="hasBranchTask(20)")
          img(src="~assets/footprint/2025/task-12.png")
        .welcome-task.welcome-task-12-bd(v-else, @click="onShowBranchVideo(2)")
          img(src="~assets/footprint/task-12-bd.png")
      //- 继续集1个支线贴纸就可开启分享与留言按钮 留言区文字变化
      template(v-if="!showSharedLoading")
        .welcome-btn(v-if="canShared", @click="onShare") 分享
      template(v-else)
        .welcome-info
          dl
            dt WELCOME TO ALIPAY LAB.
            dd 上海市浦东新区南泉北路447号支付宝S空间<br />S Space, No. 447 Nanquan North Road, Pudong New Area, Shanghai
          img(src="~assets/footprint/qrcode.png")
        .welcome-cover.welcome-cover-line1
          img(src="~assets/footprint/line.png")
        .welcome-cover.welcome-cover-line2
          img(src="~assets/footprint/line.png")
        .welcome-cover.welcome-cover-figure
          img(src="~assets/footprint/cover-final.png")
  .welcome-guide
    Guide(:step="guideStep", @onSetGuideStep="onSetGuideStep")
  .welcome-tip
    Tip(:cover="true", title="定制贴纸正在生成中...", desc="Tips:生成后长按可保存至相册，欢迎分享到大众点评、朋友圈、小红书哦～", v-if="showSharedLoading")
    Tip(title="分享前先留言吧～", v-if="showSharedTip")
  //- 分享图片生成
  .welcome-pic(v-if="imgUrl")
    img(:src="imgUrl")
    .welcome-pic-back(:style="`height: ${backHeight}px;`", @click="onPicBack")
  //- 盲盒
  .welcome-box(v-if="showBlindbox")
    Blindbox(@close="onHideBlindbox", :qrcode="footprintQrcode.qrCode")
  //- 支线视频
  BranchVideo(:backHeight="backHeight", v-if="showBranchVideo", @close="onHideBranchVideo", :branchVideo="branchVideo", :key="branchVideo.toString()")
  //- 支线问答 飞跃蚂蚁森林
  BranchQue(:backHeight="backHeight", v-if="showBranchQue", @close="onHideBranchQue")
  //- 支线问答  天空之眼
  BranchQue2(:backHeight="backHeight", v-if="showBranchQue2", @close="onHideBranchQue2")
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import html2canvas from 'html2canvas'
import Guide from '@/components/footprint/Guide'
import Tip from '@/components/footprint/Tip'
import Blindbox from '@/components/footprint/Blindbox'
import BranchVideo from '@/components/footprint/BranchVideo'
import BranchQue from '@/components/footprint/BranchQue'
import BranchQue2 from '@/components/footprint/BranchQue2'
export default {
  name: 'Welcome',
  components: { Guide, Tip, Blindbox, BranchVideo, BranchQue,BranchQue2 },
  props: {},
  data() {
    return {
      guideStep: 3,
      sharedText: '',
      showSharedTip: false,
      showSharedLoading: false,
      imgUrl: '',
      showBlindbox: false,
      showBranchVideo: false,
      showBranchQue: false,
      showBranchQue2:false,
      branchVideo: {},
      branchVideoList: [
        { name: '紫丁香法治课堂', url: 'https://antlab-mp.zjian.cc/imgs/mp/task/Rule-of-Law-Classroom.mp4', code: 19 },
        { name: '环境教育基地', url: 'https://antlab-mp.zjian.cc/imgs/mp/task/Environmental-Education-Base.mp4', code: 18 },
        { name: '家+书屋', url: 'https://antlab-mp.zjian.cc/imgs/mp/task/Home+Bookstore.mp4', code: 20 },
        { name: '天空之眼', url: 'https://antlab-mp.zjian.cc/imgs/mp/task/sky_eye.m4v', code: 5 },
        // { name: '互动区', url: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', code: 2 },
        // { name: '蚂蚁链NFT', url: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', code: 3 },
        // { name: '零碳行动', url: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', code: 7 },
        // { name: '天空之眼', url: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4', code: 4 },
      ],
    }
  },
  watch: {},
  computed: {
    ...mapState('app', ['sysInfo', 'router', 'user', 'footprintTaskListToday', 'footprintServiceTime', 'footprintQrcode']),
    canShared() {
      return this.footprintTaskListToday.masterTask.length === 4 && this.footprintTaskListToday.branchTask.length==5;
    },
    placeholder() {
      return this.canShared ? '分享今日好心情｜' : '收集12张贴纸来留言吧！';
    },
    backHeight() {
      return this.sysInfo.titleBarHeight + this.sysInfo.statusBarHeight * 2;
    }
  },
  methods: {
    ...mapMutations('app', ['setPending']),
    ...mapActions('app', ['GetFootprintTaskListToday','GetFootprintAddTaskBranchFinish', 'GetFootprintServiceTime', 'GetFootprintCreateQRCodeStr']),
    onBack() {
      console.log(this.router.back);
      this.$router.replace(this.router.back);
    },
    onShare() {
      if (this.sharedText === '') {
        this.showSharedTip = true;
        setTimeout(() => {
          this.showSharedTip = false;
        }, 2000);
        return;
      }

      this.showSharedLoading = true;
      this.$nextTick(() => {
        html2canvas(document.getElementById('welcome')).then(canvas => {
          const dataURL = canvas.toDataURL('image/png');
          this.imgUrl = dataURL
        });
      });
    },
    hasMasterTask(taskId) {
      return !!this.footprintTaskListToday.masterTask.find(({ id }) => id === taskId);
    },
    hasBranchTask(taskId) {
      return !!this.footprintTaskListToday.branchTask.find(({ id }) => id === taskId);
    },
    onGuide() {
      this.onSetGuideStep(3);
    },
    onSetGuideStep(step) {
      this.guideStep = step;
    },
    onShowBlindbox() {
      this.showBlindbox = true;
      if (!this.footprintQrcode.qrCode) {
        this.fetchFootprintCreateQRCodeStr();
      }
    },
    onHideBlindbox() {
      this.showBlindbox = false;
    },
    onShowBranchVideo(index) {
      this.branchVideo = this.branchVideoList[index];
      this.showBranchVideo = true;
      // if (this.isFinish) {
      //   return;
      // }
      // this.GetFootprintAddTaskBranchFinish({
      //   userId: this.user.id,
      //   taskBranchId: this.branchVideoList[index].code,
      // })
      //   .then(() => {
      //     // 需要同步支线数据？
      //     this.GetFootprintTaskListToday({ userId: this.user.id });
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //   })
    },
    onHideBranchVideo() {
      this.showBranchVideo = false;
    },
    onShowBranchQue() {
      this.showBranchQue = true;
      //      this.GetFootprintAddTaskBranchFinish({
      //   userId: this.user.id,
      //   taskBranchId: 7,
      // })
      //   .then(() => {
      //     // 需要同步支线数据？
      //     this.GetFootprintTaskListToday({ userId: this.user.id });
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //   })
    },
    onShowBranchQue2() {
      this.showBranchQue2 = true;
    },
    onHideBranchQue() {
      this.showBranchQue = false;
    },
    onHideBranchQue2(){
      this.showBranchQue2 = false;
    },
    onPicBack() {
      this.imgUrl = '';
      this.showSharedLoading = false;
    },
    fetchFootprintTaskListToday() {
      this.setPending(true)
      this.GetFootprintTaskListToday({ userId: this.user.id })
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
    fetchFootprintServiceTime() {
      this.setPending(true)
      this.GetFootprintServiceTime({ format: 'yyyy-MM-dd HH:mm:ss' })
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
    fetchFootprintCreateQRCodeStr() {
      this.setPending(true)
      this.GetFootprintCreateQRCodeStr({ userId: this.user.id })
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
  },
  created() {
    this.fetchFootprintTaskListToday();
    this.fetchFootprintServiceTime();
  },
  mounted() { },
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint"
.welcome
  background: url("~assets/footprint/bg-body.png") top center repeat
  background-size: pxRes(414);
.welcome-head
  height: pxRes(122); position: relative
  &-back
    box-sizing: content-box; padding: 0 pxRes(16.54); width: pxRes(21)
    position: absolute; top: 0; left: 0
    background: url("~assets/back-btn.png") center no-repeat
    background-size: pxRes(11)
.welcome-head-share
  height: pxRes(186); padding-top: pxRes(70.5); text-align: center
  background: linear-gradient(180deg, #E4EEF3 0%, rgba(228, 238, 243, 0) 100%)
  position: relative
  img
    +image; width: pxRes(383.5)
.welcome-body
  height: pxRes(774); position: relative
.welcome-body-share
  height: pxRes(750); position: relative
  background: url("~assets/footprint/bg-body-share.png") center no-repeat
  background-size: cover
.welcome-ask
  position: absolute; width: pxRes(27); height: pxRes(27)
  left: pxRes(378); top: pxRes(1)
  background: url("~assets/footprint/icon-ask.png") center no-repeat
  background-size: pxRes(27)
.welcome-msg
  position: absolute; width: pxRes(208); height: pxRes(219)
  left: pxRes(20); top: pxRes(1.12)
  background: #FFFFFF; border: 1px solid #000000
  &-name
    +text(24.6, 54); background: #9CD1F0; font-weight: bold
    padding: 0 pxRes(10) 0 pxRes(13.35); border-bottom: 1px solid #000000
    +textOverflow
  &-text
    height: pxRes(158); border-bottom: 1px solid #000000
    textarea, p
      +inline-block; width: pxRes(174); border: 0; box-sizing: content-box
      +text(16, 23); height: pxRes(92); font-family: inherit;
      padding: pxRes(12) pxRes(13) 0; resize: none; outline: 0
      user-select: text
      &:disabled
        color: #C0C0C0; background: #FFFFFF
  &-time
    position: absolute; left: pxRes(14); bottom: pxRes(10)
    +text(7.6, 11); color: #000000
  &-icon
    position: absolute; right: pxRes(14); bottom: pxRes(12); height: pxRes(30)
    img
      +image; width: pxRes(26)
.welcome-task
  position: absolute
  img
    +image
  &-1
    left: pxRes(243); top: pxRes(1); width: pxRes(69)
  &-2
    left: pxRes(32); top: pxRes(515); width: pxRes(145.5)
  &-3
    left: pxRes(326); top: pxRes(29); width: pxRes(76)
  &-4
    left: pxRes(101); top: pxRes(220); width: pxRes(151); z-index: 1
  &-5
    left: pxRes(56); top: pxRes(322); width: pxRes(117.5)
  &-6
    left: pxRes(165); top: pxRes(514); width: pxRes(127)
  &-7
    left: pxRes(327); top: pxRes(124); width: pxRes(75)
  &-8, &-8-bd 
    left: pxRes(15); top: pxRes(240); width: pxRes(89.5)
  &-9, &-9-bd 
    left: pxRes(12); top: pxRes(424); width: pxRes(148)
  &-10, &-10-bd 
    left: pxRes(173); top: pxRes(428); width: pxRes(77)
  &-11, &-11-bd 
    left: pxRes(293); top: pxRes(438); width: pxRes(116)
  &-12, &-12-bd 
    left: pxRes(284); top: pxRes(560); width: pxRes(83.5)
.welcome-info
  position: absolute; bottom: pxRes(26); width: pxRes(414); left: 0; display: flex
  padding-right: pxRes(28); align-items: flex-end
  dl
    margin: 0; padding-left: pxRes(22); flex: 1
  dt
    +text(20, 28); font-weight: 900
  dd
    +text(9, 12); margin: 0; padding-top: pxRes(10)
  img
    width: pxRes(56); height: pxRes(56)
.welcome-cover
  position: absolute
  img
    +image
  &-line1
    left: pxRes(68); top: pxRes(-11); width: pxRes(53)
  &-line2
    left: pxRes(297); top: pxRes(-11); width: pxRes(53)
  &-figure
    left: pxRes(0); top: pxRes(-11); width: pxRes(414)
.welcome-btn
  position: absolute; bottom: pxRes(34); left: pxRes(13); right: pxRes(13)
  +text(20, 28); background: #1677FF; color: #FFFFFF
  border-radius: pxRes(4.5); padding: pxRes(13); text-align: center
.welcome-pic
  +full; z-index: 9999
  img
    +image
  &-back
    box-sizing: content-box; padding: 0 pxRes(16.54); width: pxRes(21)
    position: absolute; top: 0; left: 0
    background: url("~assets/back-btn.png") center no-repeat
    background-size: pxRes(11)
</style>

